/**
 * @generated SignedSource<<b24ae1671aabcfc2e57721eda80b0987>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EthereumAmountInput_etherRates$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"useEtherConversion_etherRates">;
  readonly " $fragmentType": "EthereumAmountInput_etherRates";
}>;
export type EthereumAmountInput_etherRates$key = ReadonlyArray<{
  readonly " $data"?: EthereumAmountInput_etherRates$data;
  readonly " $fragmentSpreads": FragmentRefs<"EthereumAmountInput_etherRates">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "EthereumAmountInput_etherRates",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useEtherConversion_etherRates"
    }
  ],
  "type": "EtherRates",
  "abstractKey": null
};

(node as any).hash = "b4e9039acd1146bb385ebf36c748671f";

export default node;
